import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const getProductGroups = async () => {

    const resp = await api(`/api/jsonws/invoke`, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/management.childparam/search-by-parent-code': {
                    'parentCode': 'T_GRUPOS_CAJASORPRESA'
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();
    
    return data;
}